import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import io from "socket.io-client";

const BangkokBankLinkGuide = () => {
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (location.state && location.state.url && location.state.transactionId) {
            setTimeout(() => {
                window.location.href = location.state.url;
            }, 500);

            const socket = io({ transports: ['websocket'], auth: { transactionId: location.state.transactionId } });
            socket.on("duitnowPayment", () => {
                if (location.state.role === "staff") {
                    history.push("/staff");
                } else {
                    history.push("/thankyou");
                }
            });

            return () => {
                socket.disconnect();
            };
        }

    }, []);

    return (
        <div className="text-center" style={{ paddingTop: "100px" }}>
            <h4>Redirecting to Bangkok Bank App...</h4>

            {location.state?.url && (
                <button
                    type="button"
                    className="btn btn-primary mt-3"
                    onClick={() => window.location.href = location.state.url}
                >
                    Open Bangkok Bank App now
                </button>
            )}
        </div>
    );
};

export default BangkokBankLinkGuide;